import { render, staticRenderFns } from "./EditResultsModal.vue?vue&type=template&id=bd590004&scoped=true&"
import script from "./EditResultsModal.vue?vue&type=script&lang=js&"
export * from "./EditResultsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditResultsModal.vue?vue&type=style&index=0&id=bd590004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd590004",
  null
  
)

export default component.exports